import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    OutlinedInput,
    FormHelperText
} from '@mui/material';
import { SET_LOADING, SET_MODAL_STATUS } from 'store/actions';
import axios from 'utils/axios';
import { useDispatch, useSelector } from 'react-redux';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { useTheme } from '@mui/material/styles';

function PlansModal() {
    const dispatch = useDispatch();
    const theme = useTheme();
    const [plansList, setPlansList] = useState([]);
    const [errorMsg, setErrorMsg] = useState('');
    const [userBaseRange, setUserBaseRange] = useState(0);
    const { userData } = useSelector((state) => state.customization);
    const handleClick = (plan) => {
        if (!userBaseRange) {
            setErrorMsg('Numbers of shareholder is required');
            return;
        }
        dispatch({ type: SET_LOADING, loading: true });
        let variables = {
            userBaseRange: userBaseRange,
            priceId: plan.default_price
        };
        axios({
            method: 'POST',
            url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/subscribe',
            headers: {
                'Content-Type': 'application/json'
            },
            data: variables
        }).then(function (response) {
            dispatch({ type: SET_LOADING, loading: false });
            if (response.data.url) {
                window.location.href = response.data.url;
            }
        });
    };
    useEffect(() => {
        axios({
            method: 'GET',
            url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/products'
        }).then(function (response) {
            setPlansList(response.data.data);
        });
    }, []);

    const getPrice = (price) => {
        let data = price / 100;
        return data.toFixed(2);
    };
    return (
        <>
            <Box className="modal-header">
                <Typography variant="h3">Subscription</Typography>
            </Box>
            <Box className="modal-body">
                <Grid container>
                    {plansList &&
                        plansList.map((plan, index) => (
                            <Grid item xs={12} key={index} margin={2}>
                                <Card sx={{ padding: '0!important' }}>
                                    {plan.images && plan.images.length > 0 && (
                                        <CardMedia component="img" height="140" image={plan.images[0]} alt="green iguana"></CardMedia>
                                    )}
                                    <CardContent>
                                        <Typography gutterBottom variant="h3" component="div">
                                            {plan.name}
                                        </Typography>
                                        {plan.pricelist && plan.pricelist.tiers.length > 0 && (
                                            <Typography variant="h5" style={{ marginBottom: 2 }}>
                                                Starts at ${getPrice(plan.pricelist.tiers[0].unit_amount)} /{' '}
                                                {plan.pricelist.recurring.interval}
                                            </Typography>
                                        )}
                                        {plan.description && <Typography variant="p">{plan.description}</Typography>}
                                    </CardContent>
                                    <CardActions>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <FormControl>
                                                    <FormControl sx={{ ...theme.typography.customInput }}>
                                                        <InputLabel htmlFor="outlined-adornment-member-name">
                                                            Number of shareholders
                                                        </InputLabel>
                                                        <OutlinedInput
                                                            id="outlined-adornment-member-name"
                                                            type="number"
                                                            name="inputFile"
                                                            placeholder="Shareholders"
                                                            inputProps={{ min: 1 }}
                                                            onChange={(e) => setUserBaseRange(e.target.value)}
                                                        />
                                                        {errorMsg && (
                                                            <FormHelperText error id="standard-weight-helper-text-email-login">
                                                                {errorMsg}
                                                            </FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sx={{ mt: 2 }}>
                                                <AnimateButton>
                                                    <Button
                                                        variant="filled"
                                                        className="medium filled secondary"
                                                        onClick={() => handleClick(plan)}
                                                    >
                                                        Subscribe
                                                    </Button>
                                                </AnimateButton>
                                            </Grid>
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        ))}
                </Grid>
            </Box>
        </>
    );
}
export default PlansModal;
